const ARC_RADIUS = 7
const ARC_CENTRE_X = 8.5
const ARC_CENTRE_Y = 8.5
const ARC_SELECTED_COLOR = 0xffd900
const ARC_DESELECTED_COLOR = 0x0000ff

export default class Item extends Phaser.Sprite {
  constructor (game, stack, name) {
    super(game, 0, 0, 'sloth', name)
    this.stack = stack

    this.maxCount = 0
    this.count = 0

    this.selected = false

    this.usedGraphics = new Phaser.Graphics(this.game, 0, 0)
    this.usedGraphics.lineStyle(1, 0x666666)
    this.usedGraphics.drawCircle(ARC_CENTRE_X, ARC_CENTRE_Y, ARC_RADIUS * 2)
    this.addChild(this.usedGraphics)

    this.unusedGraphics = new Phaser.Graphics(this.game, 0, 0)
    this.addChild(this.unusedGraphics)
    this.drawUnusedArc()

    this.description = 'ITEM'
  }

  drawUnusedArc () {
    const from = 270 - (360 * (this.count / this.maxCount))

    this.unusedGraphics.clear()

    if (this.selected) this.unusedGraphics.lineStyle(1, ARC_SELECTED_COLOR)
    else this.unusedGraphics.lineStyle(1, ARC_DESELECTED_COLOR)

    this.unusedGraphics.arc(ARC_CENTRE_X, ARC_CENTRE_Y, ARC_RADIUS, this.game.math.degToRad(from), this.game.math.degToRad(270), false)
  }

  setTo (count) {
    this.visible = true
    this.count = count
    this.maxCount = count
    this.drawUnusedArc()
  }

  reset () {
    this.visible = false
    this.count = 0
    this.maxCount = 0
    this.drawUnusedArc()
  }

  select (selected) {
    this.selected = selected
    this.drawUnusedArc()
  }

  use () {
    if (this.count === 0 || this.stack.count < this.operands.length) {
      return false
    }

    this._activate()
    this.count--
    if (this.count <= 0) {
      this.alpha = 0.5
    }

    this.drawUnusedArc()

    return true
  }

  _activate () {
    // Implement in child classes
  }
}
